import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { BalanceLoaderInfoProvider, BalanceSheetViewModel, singleBalance, singleFilter } from "./balanceSheet-viewModel"

export class BalanceSheetView extends View<BalanceSheetViewModel>{
    GetViewUniqueId(): string {
        return "V-5B209D66-48CB-4C52-AA81-F71738EB5302"
    }
    loadHtml(): string {
        let element = require('./balanceSheet.html').default;
        let style = require('./balanceSheet.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set filters(v: ObservableArray<singleFilter>) { this._filters = v; } public get filters(): ObservableArray<singleFilter> { return this._filters;} private _filters: ObservableArray<singleFilter>;
    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loaders(v: ObservableArray<BalanceLoaderInfoProvider>) { this._loaders = v; } public get loaders(): ObservableArray<BalanceLoaderInfoProvider> { return this._loaders;} private _loaders: ObservableArray<BalanceLoaderInfoProvider>;
    public set showFiltersTooltip(v: boolean) { this._showFiltersTooltip = v; } public get showFiltersTooltip(): boolean { return this._showFiltersTooltip;} private _showFiltersTooltip: boolean;
    
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    
    
    getRelatedTransactions(){
        this.dataContext.getRelatedTransactions()
    }
}
